import { render, staticRenderFns } from "./ProducerModal.vue?vue&type=template&id=60968ae7&"
import script from "./ProducerModal.vue?vue&type=script&lang=js&"
export * from "./ProducerModal.vue?vue&type=script&lang=js&"
import style0 from "./ProducerModal.vue?vue&type=style&index=0&id=60968ae7&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports